import React from 'react'
import { EventAvatar } from '../../../events/components/EventAvatar'

interface PersonAvatarProps {
  uri: string | null
  firstName?: string
  lastName?: string
  size?: number
}

/**
 * Round photo of a person; without one, their initials (same avatar as the
 * event pages) — never a stock photo that could pass for someone else.
 */
export const PersonAvatar: React.FC<PersonAvatarProps> = ({
  uri,
  firstName = '',
  lastName,
  size = 48,
}) => <EventAvatar firstName={firstName} lastName={lastName} avatarUrl={uri} size={size} />
